import './styles/App.css';

import { useEffect, useState } from 'react';

import NavBar from './components/NavBar';
import ContentContainer from './components/ContentContainer';

import { demoData } from './demoData';

function App() {
  const [activeId, setActiveId] = useState('chart');
  const [activeTimeId, setActiveTime] = useState('allTime');
  const [activeWeightUnit, setActiveWeightUnit] = useState('lbs');
  const [weightList, setWeightList] = useState(demoData);
  const [filteredWeightList, setFilteredWeightList] = useState(weightList);

  const onNavClick = (buttonId) => {
    setActiveId(buttonId);
  }

  const onTimeClick = (timeId) => {
    setActiveTime(timeId);
  }

  const onWeightUnitClick = (weightUnit) => {
    setActiveWeightUnit(weightUnit)
  }

  const onAddNewWeight = (weight) => {
    const date = Date.now();
    const kgToLb = 2.2046226218;
    if (activeWeightUnit === 'kgs') weight *= kgToLb;
    setWeightList([{date, weight}, ...weightList]);
  }

  const onEditWeight = (weight, date) => {
    setWeightList(weightList.map((weightItem) => weightItem.date === date ? {...weightItem, weight: weight} : weightItem));
  }

  const deleteWeightItem = (weightKey) => {
    setWeightList(weightList.filter(weightItem => weightItem.date !== weightKey));
  }

  const filterWeights = () => {
    // Deep copy the weightList
    let filteredWeights = JSON.parse(JSON.stringify(weightList));
    const currentDateTime = Date.now();
    switch (activeTimeId) {
      case 'year':
        const yearInMilliseconds = 365 * 24 * 60 * 60 * 1000;
        filteredWeights = filteredWeights.filter(weightItem => currentDateTime - weightItem.date < yearInMilliseconds);
        break;
      case 'month':
        const monthInMilliseconds = 30 * 24 * 60 * 60 * 1000;
        filteredWeights = filteredWeights.filter(weightItem => currentDateTime - weightItem.date < monthInMilliseconds);
        break;
      case 'week':
        const weekInMilliseconds = 7 * 24 * 60 * 60 * 1000;
        filteredWeights = filteredWeights.filter(weightItem => currentDateTime - weightItem.date < weekInMilliseconds);
        break;
      case 'day':
        const dayInMilliseconds = 24 * 60 * 60 * 1000;
        filteredWeights = filteredWeights.filter(weightItem => currentDateTime - weightItem.date < dayInMilliseconds);
        break;
      default:
        break;
    }
    const lbToKg = 0.45359237
    if (activeWeightUnit === 'kgs') {
      filteredWeights.forEach( weightItem => {
        weightItem.weight = weightItem.weight * lbToKg;
      });
    }
    setFilteredWeightList(filteredWeights);
  }

  useEffect(
    () => {
      filterWeights();
    }, [weightList, activeTimeId, activeWeightUnit]
  )

  return (
    <div className="fillWindow">
      <NavBar onClick={onNavClick} activeButton={activeId}/>
      <ContentContainer 
        onTimeClick={onTimeClick} 
        onWeightUnitClick={onWeightUnitClick}
        weightsData={filteredWeightList} 
        activeNavButton={activeId} activeTimeId={activeTimeId} activeWeightUnit={activeWeightUnit}
        onAddNewWeight={onAddNewWeight}
        onEditWeight={onEditWeight}
        onDelete={deleteWeightItem}/>
    </div>
  );
}

export default App;
